var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ConfirmDialog',{attrs:{"loading":_setup.isSubmitting},on:{"confirm":_setup.confirm,"cancel":_setup.onCancel},model:{value:(_setup.showModal),callback:function ($$v) {_setup.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"message"},[_c('p',{staticClass:"m-0 p-0"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }